import React from "react";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
} from "@syos-music/instruments";

import { Grid } from "@mui/material";

export default function OptionsFields({ cartItem, name }) {
  const { instrument } = cartItem.product.defaultOptions;

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          name={`${name}.instrumentType`}
          instrument={instrument}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField name={`${name}.ligatureColor`} allowPrivate />
      </Grid>
    </Grid>
  );
}
